const map = {
	"./home": 6184,
	"./home.js": 6184,
	"./slides/4 bilhoes de infinitos 2.jpg": 4870,
	"./slides/Abdução 3.jpg": 4802,
	"./slides/Anderson 1.jpg": 6161,
	"./slides/Morro do Cemitério 3.jpg": 3172,
	"./slides/Serrão 2.jpg": 5398
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9314;